// PaymentLoadingOverlay.jsx
import React from 'react';
import { Loader } from 'lucide-react';

const PaymentLoadingOverlay = ({ isVisible, message }) => {
  if (!isVisible) return null;
  
  return (
    <div className="fixed inset-0 backdrop-blur-sm bg-black/30 flex items-center justify-center z-50">
      <div className="bg-[#1e293b] rounded-xl p-8 max-w-md mx-auto shadow-xl border border-gray-700 text-center">
        <Loader className="h-12 w-12 text-[#ff7e00] mx-auto animate-spin mb-4" />
        <h3 className="text-xl font-medium text-white mb-2">
          {message || "Processing your payment..."}
        </h3>
        <p className="text-gray-300 text-sm">
          Please wait while we connect to Payment Gateway. Do not close this window.
        </p>
      </div>
    </div>
  );
};

export default PaymentLoadingOverlay;